import { api, CHAT_HISTORY_LIST_TAG } from '@/api';
import { setAllChatHistoryList, type RootState } from '@/store';
import { handleQueryLifecycle } from '../utils';

export interface DeleteChatRequest {
  chatId: string;
}

export interface DeleteChatResponse {
  success: boolean;
}

const deleteChatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteChat: builder.mutation<DeleteChatResponse, DeleteChatRequest>({
      query: ({ chatId }) => ({
        url: '/chat/delete',
        method: 'POST',
        body: {
          chat_id: chatId,
        },
      }),
      invalidatesTags: () => [{ type: CHAT_HISTORY_LIST_TAG }],
      async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        await handleQueryLifecycle(queryFulfilled, () => {
          const state = getState() as RootState;
          const updatedChats = state.chatHistory.allChatHistoryList.filter((chat) => chat.chatId !== arg.chatId);
          dispatch(setAllChatHistoryList(updatedChats));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useDeleteChatMutation } = deleteChatApi;
